var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTxsaver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 96C0 42.9807 42.9807 0 96 0C149.019 0 192 42.9807 192 96C192 149.019 149.019 192 96 192C42.9807 192 0 149.019 0 96Z",
    fill: "url(#paint0_linear_2422_44138)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0031 36.1819C96.3563 35.9394 95.6435 35.9394 94.9967 36.1819L49.2817 53.325C48.1665 53.7432 47.4277 54.8093 47.4277 56.0003V96.0009C47.4277 114.42 59.6615 129.431 71.2609 139.58C77.1207 144.708 82.967 148.725 87.3426 151.46C89.5334 152.83 91.3632 153.882 92.6518 154.595C93.2963 154.952 93.806 155.224 94.1584 155.409C94.3346 155.502 94.4715 155.573 94.5664 155.621L94.6768 155.677L94.7078 155.693L94.7201 155.699C95.5245 156.101 96.4784 156.1 97.2827 155.698L97.292 155.693L97.3229 155.677L97.4333 155.621C97.5282 155.573 97.6652 155.502 97.8414 155.409C98.1938 155.224 98.7035 154.952 99.348 154.595C100.637 153.882 102.466 152.83 104.657 151.46C109.033 148.725 114.879 144.708 120.739 139.58C132.338 129.431 144.572 114.42 144.572 96.0009V56.0003C144.572 54.8093 143.833 53.7432 142.718 53.325L97.0031 36.1819ZM76.5645 118.139V76.6526H63.6729V70.1382H97.4523L107.807 87.4184L117.887 70.1382H126.047L111.715 93.9328L126.184 118.139H117.887L107.395 100.653L97.4523 118.139H89.155L103.487 94.1385L92.9451 76.6526H83.8331V118.139H76.5645Z",
    fill: "url(#paint1_linear_2422_44138)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2422_44138",
    x1: -92.961,
    y1: 92.961,
    x2: 92.961,
    y2: 278.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#284D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2422_44138",
    x1: 0.393206,
    y1: 94.1006,
    x2: 114.048,
    y2: 186.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51EB98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40A3FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxsaver);
export default __webpack_public_path__ + "static/media/txsaver.6fef539eb13066d371ce1eec3a9e6392.svg";
export { ForwardRef as ReactComponent };